import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import CInput from '@/components/CForm/CInput'
import { storeManageListNewData} from './data'
import { insertStoreList, editStoreList} from "@/servers/storeManageApi";
import {setPageNewItem, urlFormat} from "@/utils";
import './index.scss'
import {Button, Modal, Tooltip} from "antd";
import wenhao from '@/assets/images/wenhao.png'
import important from '@/assets/images/important.png'
import { compose } from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";


@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }


  state = {
    data: storeManageListNewData,
    addressInfo: null,
    searchData: {
      value: '',//搜索框筛选
      placeholder: '请输入评分'
    },
    isModalVisible:false
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

  onChange(data){
    let currentOption = null;
    if(data.data.id === 'address'){
      currentOption = data.data.options.filter(item=>{
        return item.value === data.value;
      });
    }
    this.setState({
      data: setPageNewItem(this.state.data, data.data.id, 'value', data.value),
      addressInfo: currentOption && currentOption.length ? currentOption[0] : null
    })
  }

  onSearch(data, value){
    if(data.data.id === 'address'){
      this.getAMapKeywordsSearchData(data.value);
    }else if(data.data.id === 'user'){
      this.getUserBusniessListData(data);
    }
  }


  onSubmit(data){
    if(data.data.avatarImg){
      let imgArr = [];
      data.data.avatarImg.forEach(item=>{
        imgArr.push({
          id: item.uid,
          url: item.url
        })
      });
      data.data.avatarImg = imgArr.length ? imgArr[0] : '';
    }
    let method = null;
    if(urlFormat(this.props.history.location.search).query.type === 'edit'){
      data.data.id = urlFormat(this.props.history.location.search).query.id;
      method = editStoreList;
    }else{
      method = insertStoreList
    }

    data.data.address = this.state.addressInfo ? this.state.addressInfo.name : '';
    data.data.latlong = this.state.addressInfo ? this.state.addressInfo.location : [0,0];

    method(data.data).then(res=>{
      this.props.history.goBack();
    }).catch(err=>{

    });
  }

  render(){
    console.log(this.props.collapsed)
    return (
      <div className='detail-container' id="top">
        <div className="detail-item">
            <div className='detail-title'>
              <span>新增制度数量</span>
              <div className='detail-score'>
                <span className='required'>*</span>
                <CInput value={this.state.searchData.value}
                        className='search-input'
                        placeholder={this.state.searchData.placeholder} />
                <div className='scoreintro'>(0-10分)</div>
                <Tooltip placement="bottom" title='打分说明'>
                  <img src={wenhao} alt="" style={{width:'15px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
                </Tooltip>
              </div>
            </div>
            <div className='detail-content'>
              新增制度数量内容
            </div>
            <div className='detail-info'>
              <div className='info-icon'>
                <img src={important} alt=""/>
              </div>
              <div>
                评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明
              </div>
            </div>
          </div>
        <div className="detail-item">
          <div className='detail-title'>
            <span>简介博物馆章程制定执行情况</span>
            <div className='detail-score'>
              <span className='required'>*</span>
              <CInput value={this.state.searchData.value}
                      className='search-input'
                      placeholder={this.state.searchData.placeholder} />
              <div className='scoreintro'>(0-10分)</div>
              <Tooltip placement="bottom" title='打分说明'>
                <img src={wenhao} alt="" style={{width:'15px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
              </Tooltip>
            </div>
          </div>
          <div className='detail-content'>
            博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容
            博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容博物馆章程制定执行情内容
          </div>
          <div>
            <Button type="primary" className='yl' onClick={this.showModal}>附件预览</Button>
          </div>
          <div className='detail-info'>
            <div className='info-icon'>
              <img src={important} alt=""/>
            </div>
            <div>
              评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明
            </div>
          </div>
        </div>
        <div className="detail-item">
          <div className='detail-title'>
            <span>简介博物馆中长期发展规划编制、执行情况</span>
            <div className='detail-score'>
              <span className='required'>*</span>
              <CInput value={this.state.searchData.value}
                      className='search-input'
                      placeholder={this.state.searchData.placeholder} />
              <div className='scoreintro'>(0-10分)</div>
              <Tooltip placement="bottom" title='打分说明'>
                <img src={wenhao} alt="" style={{width:'15px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
              </Tooltip>
            </div>
          </div>
          <div className='detail-content'>
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
          </div>
          <div>
            <Button type="primary" className='yl' onClick={this.showModal}>附件预览</Button>
          </div>
          <div className='detail-info'>
            <div className='info-icon'>
              <img src={important} alt=""/>
            </div>
            <div>
              评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明
            </div>
          </div>
        </div>
        <div className="detail-item">
          <div className='detail-title'>
            <span>简介博物馆内部管理制度体系建设、完善、更新情况</span>
            <div className='detail-score'>
              <span className='required'>*</span>
              <CInput value={this.state.searchData.value}
                      className='search-input'
                      placeholder={this.state.searchData.placeholder} />
              <div className='scoreintro'>(0-10分)</div>
              <Tooltip placement="bottom" title='打分说明'>
                <img src={wenhao} alt="" style={{width:'15px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
              </Tooltip>
            </div>
          </div>
          <div className='detail-content'>
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
          </div>
          <div>
            <Button type="primary" className='yl' onClick={this.showModal}>附件预览</Button>
          </div>
          <div className='detail-info'>
            <div className='info-icon'>
              <img src={important} alt=""/>
            </div>
            <div>
              评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明评分要点说明
            </div>
          </div>

        </div>
        <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 280px)',left:'280px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
          <Button type="primary" className='yl'>确定</Button>
          <Button>取消</Button>
        </div>
        <Modal title="附件预览" visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
            <div style={{width:'100%',minHeight:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
            </div>
          </Modal>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};

export default compose(withRouter, connect(mapStateToProps))(Legal);
